import {Component, inject, input, signal} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {ProviderTenderRfqControllerService} from '@frontend/shared-api';
import {Button} from 'primeng/button';
import {firstValueFrom} from 'rxjs';
import {ToastService} from '@frontend/toast';
import {APP_ROUTES} from '../../../../../app.routes';
import {Router} from '@angular/router';
import {Divider} from 'primeng/divider';
import {RfqDocumentUploadContentComponent} from './rfq-document-upload-content/rfq-document-upload-content.component';
import {SubsectionTitleComponent} from '../../../../../shared/components/header/subsection-title/subsection-title.component';
import {ConfirmationDialogService} from '../../../../../shared/components/dialog/confirmation/confirmation-dialog.service';

@Component({
  selector: 'app-tender-project-rfq-document-upload',
  imports: [
    TranslocoPipe,
    Button,
    Divider,
    RfqDocumentUploadContentComponent,
    SubsectionTitleComponent,
  ],
  templateUrl: './tender-rfq-document-upload.component.html',
})
export class TenderRfqDocumentUploadComponent {
  private readonly providerTenderRfqController = inject(ProviderTenderRfqControllerService);
  private readonly confirmDialogService = inject(ConfirmationDialogService);
  private readonly toastService = inject(ToastService);
  private readonly router = inject(Router);

  readonly tenderId = input.required<number>();
  protected readonly isPhaseCompleted = signal(false);

  finishPhase(): void {
    this.confirmDialogService.confirm({
      headerKey: 'provider.tenderWizard.phase.confirmation.header',
      messageKey: 'provider.tenderWizard.phase.confirmation.text',
      accept: async () => {
        try {
          await firstValueFrom(
            this.providerTenderRfqController.finishRfqTenderPhase({tenderId: this.tenderId()}),
          );
          await this.router.navigate([APP_ROUTES.PROVIDER_TENDERS]);
          void this.toastService.showSuccessMessage();
        } catch (err) {
          console.error('Finish Phase failed:', err);
        }
      },
    });
  }
}
